import styled from "@emotion/styled";

export const DatePicker = {
  width: '100%',
}